import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "uk-padding uk-padding-remove-horizontal uk-position-relative impx-sections-spa uk-background-fixed uk-background-center-center uk-height-1-1" }
const _hoisted_2 = { class: "uk-container" }
const _hoisted_3 = {
  class: "uk-child-width-1-2@xl uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-1@s data-uk-grid impx-spa-services uk-position-relative uk-position-z-index uk-grid-match uk-margin-bottom",
  "data-uk-grid": ""
}
const _hoisted_4 = { class: "impx-spa-service" }
const _hoisted_5 = { class: "uk-grid uk-grid-collapse" }
const _hoisted_6 = { class: "uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s" }
const _hoisted_7 = { class: "impx-spa-content" }
const _hoisted_8 = { class: "uk-label uk-label-success small" }
const _hoisted_9 = { class: "uk-margin-remove" }
const _hoisted_10 = { class: "uk-list" }



export default /*@__PURE__*/_defineComponent({
  __name: 'HobbiesContent',
  props: {
  activities: {type: Array, default: ()=> []}
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "impx-overlay dark" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "uk-flex-center",
        "data-uk-grid": ""
      }, [
        _createElementVNode("div", { class: "uk-width-3-5@xl uk-width-3-5@l uk-width-1-1@m uk-width-1-1@s" }, [
          _createElementVNode("div", { class: "impx-intro uk-text-center uk-position-relative uk-position-z-index" }, [
            _createElementVNode("h2", { class: "impx-text-white uk-margin-remove-bottom" }, "Nos espace de loisir")
          ])
        ])
      ], -1)),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.activities, (item, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s uk-position-relative" }, [
                  _createElementVNode("div", { class: "uk-height-1-1 uk-cover-container" }, [
                    _createElementVNode("canvas", {
                      width: "290",
                      height: "220"
                    }),
                    _createElementVNode("img", {
                      src: './images/heading/hobbies-4.jpg',
                      alt: "resort",
                      class: "",
                      "data-uk-cover": ""
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, "À partir " + _toDisplayString(item.price), 1),
                    _createElementVNode("h4", _hoisted_9, _toDisplayString(item?.title), 1),
                    _createElementVNode("p", null, _toDisplayString(item?.subtitle), 1),
                    _createElementVNode("ul", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.facilities, (itemFacilitie, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(['fa' , itemFacilitie?.icon])
                          }, null, 2),
                          _createTextVNode(" " + _toDisplayString(itemFacilitie?.title), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})